import React from "react";
import { ToolRendererProps } from "./types";

export const DefaultToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
}) => {
  return (
    <>
      {renderWithErrorIfFailed(
        <pre className="text-xs text-secondary-n-400 whitespace-pre-wrap">
          {JSON.stringify(args, null, 2)}
        </pre>,
      )}
    </>
  );
};
